require('./progress.scss');

export default function ProgressComponent() {
  return {
    controller: ProgressController,
    template: require('./progress.html'),
    bindings: {
      disabled: '<progressDisabled',
      value: '<',
      color: '@'
    }
  };
}

// @ngInject
class ProgressController {

  $onInit() {
    this.color = angular.isDefined(this.color) ? this.color : 'primary';
  }

  getLinearProgressValue () {
    if (angular.isDefined(this.value)) {
      return {
        'transform': 'scale(' + this.value / 100 + ', 1)'
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/progress/progress.component.js